import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import locationServices from 'images/locationServices.png';
import CustomDialog from 'components/CustomDialog';
import { useAppSelector } from 'hooks/useAppSelector';
import { Box, Link, Typography } from '@mui/material';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { setOverrideNoHomeRedirect, showSearchBar } from 'store/slices/searchBar';

const NoHomeSelected: React.FC = () => {
    const dispatch = useAppDispatch();
    const map = useAppSelector((state) => state.map);
    const auth = useAppSelector((state) => state.auth);
    const history = useHistory();

    const isCenterAvailable = map.isCenterAvailable;
    const isLoggedIn = !!auth.tokenData;

    useEffect(() => {
        console.log('isLoggedIn', isLoggedIn)
        console.log('isCenterAvailable', isCenterAvailable)
        if (isCenterAvailable || isLoggedIn) {
            history.push('/');
        }
    }, [isCenterAvailable, isLoggedIn]);

    return (
        <CustomDialog
            title="Welcome to KwadHub!"
            closeCopy="Set 'Home' manually"
            onClose={() => {
                dispatch(showSearchBar());
                dispatch(setOverrideNoHomeRedirect(true));
                history.push('/');
            }}
        >
            <Box>
                <Typography variant="body1" mb={2}>
                    To use the app, we need a starting point on the map.
                </Typography>
                <Typography variant="body1" mb={2}>
                    You can either share your current location (see image) or set a home location manually.
                </Typography>
                <Box
                    component="img"
                    src={locationServices}
                    alt="Enable location services"
                    sx={{
                        display: 'block',
                        width: '70%',
                        margin: '0 auto',
                        mb: 3,
                    }}
                />
                <Typography variant="body1" mb={2}>
                    Returning user? <Link href="/sign-in">Sign in here</Link>.
                </Typography>
                <Typography variant="body1">
                    Prefer not to share your location? Just search and pick any spot to set as home.
                </Typography>
            </Box>
        </CustomDialog>
    );
};

export default NoHomeSelected;
